<template>
  <article class="media hand" @click="selData(1)">
    <div class="media-left">
      <div class="has-background-primary has-text-white has-text-centered numero">{{numberreg}}</div>
    </div>
    <div v-show="!reg.esTotal" class="media-content">
      <div>
        <strong
          :class="active(index,selcolumn.columnProducto)"
        >Producto: {{codigoproducto}} - {{nombreproducto}}</strong>
      </div>
      <div class="datospruducto">
        <table cellspacing="0" style="width: 100%">
          <tr>
            <td style="width: 17%">
              <div style="float:left;">
                <span :class="active1(index,selcolumn.columnCantidad)">Cantidad</span>
              </div>
              <div style="float:right;" class="fontMono has-text-right">
                <span :class="active(index,selcolumn.columnCantidad)">{{cantidad | number(2) }}</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 25%">
              <div style="float:left;">
                <span :class="active1(index,selcolumn.columnVlrunitario)">Vlr unitario:</span>
              </div>
              <div style="float:right;" class="fontMono has-text-right">
                <span :class="active(index,selcolumn.columnVlrunitario)">{{punitario | number(2) }}</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 10%">
              <div style="float:left;">
                <span :class="active1(index,selcolumn.columnDescuento)">Dcto:</span>
              </div>
              <div style="float:right;" class="fontMono has-text-right">
                <span :class="active(index,selcolumn.columnDescuento)">{{descuento}}%</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 30%">
              <div style="float:left;">Sub Total:</div>
              <div style="float:right;" class="fontMono has-text-right">{{subtotal | number(2)}}</div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 10%">
              <div style="float:left;">Iva:</div>
              <div style="float:right;" class="fontMono has-text-right">{{iva | number(2)}}%</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-show="reg.esTotal" class="media-content">
      <strong>Total</strong>
    </div>
    <div class="media-right fontMono has-text-right" style="width:20%">
      <span v-show="reg.tipo1  === '-'">-</span>
      {{total | number(2)}}
    </div>
  </article>
</template>

<script>
export default {
  computed: {
    descuento(){
      if(this.reg.descuento){
        const desc = parseFloat(this.reg.descuento);
        if(isNaN(desc)){
          return 0;
        }else{
          return desc;
        }
      }else{
        return 0
      }
    },
    total() {
      return this.subtotal + (this.subtotal * this.iva) / 100;
    },
    iva() {
      if (this.reg.objetoProducto && this.reg.objetoProducto.linea) {
        return this.reg.objetoProducto.linea.vImpuesto;
      } else {
        return 0;
      }
    },
    subtotal() {
      return this.valor - (this.valor * parseFloat(this.descuento)) / 100;
    },
    numberreg() {
      if (this.reg.esTotal) {
        return "T";
      } else {
        return this.index + 1;
      }
    },
    valor() {
      return this.cantidad * this.punitario;
    },
    codigoproducto() {
      if (this.reg.nproducto) {
        return this.reg.nproducto;
      } else {
        return "xx";
      }
    },
    nombreproducto() {
      if (this.reg.nombreproducto) {
        return this.reg.nombreproducto;
      } else {
        return "Nombre del producto";
      }
    },
    cantidad() {
      if (this.reg.cantidad) {
        const cantidad = parseFloat(this.reg.cantidad);
        if (isNaN(cantidad)) {
          return 0;
        } else {
          return cantidad;
        }
      } else {
        return 0;
      }
    },
    punitario() {
      if (this.reg.vlrUnitario) {
        return this.reg.vlrUnitario;
      } else {
        return 0;
      }
    }
  },
  props: {
    index: Number,
    fila: Number,
    columna: Number,
    selection: Array,
    reg: Object,
    selcolumn: Object
  },
  methods: {
    active(f, c) {
      if (c === this.columna && f === this.fila) {
        return {
          "is-select": true
        };
      } else {
        if (!this.reg[this.selection[c - 1].valida]) {
          return {
            "is-error": true
          };
        }
      }
    },
    active1(f, c) {
      if (c === this.columna && f === this.fila) {
        return {
          "is-select1": true
        };
      } else {
        if (!this.reg[this.selection[c - 1].valida]) {
          return {
            "is-error": true
          };
        }
      }
    },
    selData(c) {
      this.$emit("columna", c);
      this.$emit("fila", this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
.numero {
  font-size: 14px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 27px;
  border-radius: 20px;
}
.gris {
  color: #7a7a7a;
}
.textcuenta {
  font-weight: bold;
}
.is-select {
  color: #00d1b2;
  font-size: 23px;
}
.is-select1 {
  color: #00d1b2;
  font-size: 14px;
}
.is-error {
  color: #ff3860;
}
.datospruducto {
  table,
  td,
  th {
    font-size: 14px;
    // border: 1px solid #eeeeee !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
    color: #8b8b8b !important;
  }

  tfoot {
    border: 0px !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/registrar/Viewregistrofrapvta.vue